import ConditionnementLivraisonFermetureMl from "./conditionnement-livraison-fermeture-ml";

export default class BonLivraisonSettingsMl {
  comment: string;
  message: string;
  plcMessageList: number[];
  plcCommentList: number[];
  plcList: number[];
  planProductionIdList: number[];
  planProductionDetailIdList: number[];
  displayTotalAndPOR : boolean;
  displayVariante : boolean;
  displayNbPortionsParContenant : boolean;
  dateStart: Date;
  dateEnd: Date;
  switchDatesByCombination: ConditionnementLivraisonFermetureMl[];
}
